import React, { useState } from 'react';
import { CountdownTimer } from './CountdownTimer';
export function Pricing() {
  const [selectedPlan, setSelectedPlan] = useState<'standard' | 'elite'>('elite');
  const handleCheckout = () => {
    if (selectedPlan === 'standard') {
      window.location.href = 'https://pagos.recursosfitness.shop/cart/44044529172577:1';
    } else {
      window.location.href = 'https://pagos.recursosfitness.shop/cart/44044529860705:1';
    }
  };
  return <section className="py-10 md:py-16 bg-accent" id="pricing" data-id="element-250">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-251">
        {/* Urgency Banner */}
        <div className="bg-secondary-dark rounded-xl md:rounded-2xl p-4 md:p-8 mb-6 md:mb-10 shadow-xl border border-secondary relative overflow-hidden" data-id="element-252">
          <div className="absolute top-0 left-0 w-full h-1 bg-primary" data-id="element-253"></div>
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-8" data-id="element-254">
            <div className="text-center md:text-left flex-1" data-id="element-255">
              <div className="inline-block bg-primary text-white font-bold px-2 py-0.5 md:px-3 md:py-1 rounded-md text-xs md:text-sm mb-2 md:mb-3" data-id="element-256">
                68%
              </div>
              <h3 className="text-white text-lg md:text-2xl font-bold mb-1 md:mb-2" data-id="element-257">
                EL PRECIO DE LANZAMIENTO TERMINA EN:
              </h3>
              <p className="text-secondary-light text-xs md:text-sm" data-id="element-258">
                Después sube $8.000 ARS y no vuelve a bajar.
              </p>
            </div>

            <div className="flex-1 w-full md:w-auto" data-id="element-259">
              <CountdownTimer data-id="element-260" />
            </div>
          </div>

          <div className="mt-4 md:mt-8 pt-4 md:pt-6 border-t border-white/10" data-id="element-261">
            <div className="flex justify-between text-xs md:text-sm text-secondary-light mb-1.5 md:mb-2 font-medium" data-id="element-262">
              <span data-id="element-263">Cupos al precio de lanzamiento</span>
              <span data-id="element-264">68% tomados</span>
            </div>
            <div className="w-full bg-black/30 rounded-full h-2.5 md:h-3 overflow-hidden" data-id="element-265">
              <div className="bg-primary h-2.5 md:h-3 rounded-full" style={{
              width: '68%'
            }} data-id="element-266"></div>
            </div>
          </div>
        </div>

        <div className="text-center mb-6 md:mb-8" data-id="element-267">
          <h2 className="text-2xl md:text-4xl font-bold font-serif text-secondary-dark mb-2" data-id="element-268">
            Elegí tu Gimnasia Rítmica Infantil Resuelta
          </h2>
          <p className="text-sm md:text-base text-gray-600 font-medium" data-id="element-269">
            Las dos opciones incluyen los 6 bonos estratégicos completos
          </p>
        </div>

        {/* Compact Pricing Selector */}
        <div className="max-w-2xl mx-auto" data-id="element-270">
          <div className="flex flex-col gap-3 md:gap-4 mb-6" data-id="element-271">
            {/* Standard Option */}
            <div onClick={() => setSelectedPlan('standard')} className={`relative p-4 md:p-5 rounded-xl cursor-pointer transition-all duration-200 border-2 flex items-center gap-3 md:gap-4 bg-white shadow-sm ${selectedPlan === 'standard' ? 'border-primary shadow-md' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-272">
              {/* Radio Button */}
              <div className="flex-shrink-0" data-id="element-273">
                <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'standard' ? 'border-primary' : 'border-gray-300'}`} data-id="element-274">
                  {selectedPlan === 'standard' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-primary" data-id="element-275" />}
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 flex flex-col sm:flex-row sm:items-center justify-between gap-2" data-id="element-276">
                <div data-id="element-277">
                  <div className="flex items-center gap-2 mb-1" data-id="element-278">
                    <span className="text-xl" data-id="element-279">📘</span>
                    <h3 className="text-secondary-dark font-bold text-sm md:text-base leading-tight" data-id="element-280">
                      GIMNASIA RÍTMICA INFANTIL RESUELTA
                    </h3>
                  </div>
                  <p className="text-gray-500 text-xs md:text-sm" data-id="element-281">
                    6 Tomos + 120 clases + bonos
                  </p>
                </div>

                <div className="text-left sm:text-right" data-id="element-282">
                  <div className="text-gray-400 line-through text-xs md:text-sm" data-id="element-283">
                    $34.990
                  </div>
                  <div className="text-secondary-dark font-bold text-xl md:text-3xl" data-id="element-284">
                    $19.990
                  </div>
                </div>
              </div>
            </div>

            {/* Elite Option */}
            <div onClick={() => setSelectedPlan('elite')} className={`relative p-4 md:p-5 rounded-xl cursor-pointer transition-all duration-200 border-2 flex items-center gap-3 md:gap-4 bg-white shadow-sm ${selectedPlan === 'elite' ? 'border-primary shadow-md shadow-primary/10' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-285">
              {/* Radio Button */}
              <div className="flex-shrink-0" data-id="element-286">
                <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'elite' ? 'border-primary' : 'border-gray-300'}`} data-id="element-287">
                  {selectedPlan === 'elite' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-primary" data-id="element-288" />}
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 flex flex-col sm:flex-row sm:items-center justify-between gap-2" data-id="element-289">
                <div data-id="element-290">
                  <div className="flex items-center gap-2 mb-1.5" data-id="element-291">
                    <span className="text-xl" data-id="element-292">🏆</span>
                    <h3 className="text-secondary-dark font-bold text-sm md:text-base leading-tight" data-id="element-293">
                      PACK ÉLITE™
                    </h3>
                  </div>

                  <div className="flex flex-wrap items-center gap-2 mb-2" data-id="element-294">
                    <span className="bg-primary text-white text-[10px] md:text-xs font-bold px-2 py-0.5 rounded flex items-center gap-1" data-id="element-295">
                      ⭐ MÁS ELEGIDO
                    </span>
                    <span className="bg-primary/10 text-primary border border-primary/30 text-[10px] md:text-xs font-bold px-2 py-0.5 rounded" data-id="element-296">
                      AHORRÁS $16.000
                    </span>
                  </div>

                  <p className="text-gray-500 text-xs md:text-sm leading-tight max-w-[260px] sm:max-w-none" data-id="element-297">
                    6 Tomos + 120 clases + bonos + Coreografías + Academia
                    Rentable
                  </p>
                </div>

                <div className="text-left sm:text-right mt-2 sm:mt-0" data-id="element-298">
                  <div className="text-gray-400 line-through text-xs md:text-sm" data-id="element-299">
                    $43.990
                  </div>
                  <div className="text-primary font-bold text-xl md:text-3xl" data-id="element-300">
                    $27.990
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <button onClick={handleCheckout} className="w-full bg-primary hover:bg-primary-dark text-white font-bold text-sm md:text-lg py-3.5 md:py-4 px-4 rounded-full shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 mb-3" data-id="element-301">
            SÍ, QUIERO MI GIMNASIA RÍTMICA INFANTIL RESUELTA →
          </button>

          <p className="text-gray-500 text-center text-xs md:text-sm italic mb-5" data-id="element-302">
            La opción más elegida por instructoras de rítmica
          </p>

          {/* Trust Badges */}
          <div className="bg-white/60 border border-gray-200 rounded-lg p-3 flex flex-wrap justify-center gap-3 md:gap-6 text-[10px] md:text-xs font-medium text-gray-600" data-id="element-303">
            <div className="flex items-center gap-1.5" data-id="element-304">
              <span data-id="element-305">🔒</span> Pago seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-306">
              <span data-id="element-307">⚡</span> Acceso en 5 min
            </div>
            <div className="flex items-center gap-1.5" data-id="element-308">
              <span data-id="element-309">🛡️</span> Garantía 7 días
            </div>
            <div className="flex items-center gap-1.5" data-id="element-310">
              <span data-id="element-311">💳</span> Mercado Pago
            </div>
          </div>
        </div>
      </div>
    </section>;
}